<template>
  <div id="timelines">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left to="dashboard" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-btn fab absolute to="/timeline/add" right class="mr-3 pf-btn-fab">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>  
    </v-container>
    <v-card class="mt-3">
      <v-data-table
        :headers="headers"
        :items="Timeline" 
        :pagination.sync="pagination" 
        class="pf-data-table" 
      >
        <template v-slot:items="props">
          <td v-html="props.item.text"></td>
          <td>{{ formatDate( props.item.createdAt) }}</td>
          <td>{{ (Account.human[0].id === props.item.createdBy.human.id ? Account.human[0].name : props.item.createdBy.human.name) }}</td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
/* global session router store config */
import { getCollection, formatDate } from '../../helpers/helpers';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    pagination: {
      sortBy: 'createdAt', // The field that you're sorting by
      descending: true,
      rowsPerPage: config.dom.rowsPerPage
    },
    headers: [
      { text: 'Comment', value: 'text', align: 'left' },
      { text: 'Date', value: 'createdAt' },
      { text: 'Done By', value: 'createdBy.human.name' },
    ]
  }),
  computed: {
    ...mapGetters(['Timeline', 'Account'])
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.getTimeLines();
  },
  methods: {
    async getTimeLines () {
      if (!this.Timeline.length) {
        let entity = `Timeline`;
        let sessionUser = session.getSession();
        let where = sessionUser.adminUser ? { account: sessionUser.user.human.account.id } : {};
        let { error, data } = await getCollection(entity, true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setTimeline', data);
          }
        }
      }
    },
    formatDate (date) {
      return formatDate(date, 'MM/DD/YYYY');
    },
  }
};
</script>
<style scoped>
td >>> p {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Timelines/list.vue